/* M&R buy-box tweaks. The picker styling is now entirely CSS -- this only
   handles the two things CSS can't do: the cart button label naming the
   choice, and moving the price above the button. */
(function () {
  'use strict';

  var running = false;
  var watching = false;
  var pending = false;

  function titleCase(s) {
    return String(s).toLowerCase()
      .replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); })
      .replace(/\bDrl\b/g, 'DRL');
  }

  /* Shortens values for the cart button so the label stays on one line.
     SLIM's dual value is 45 characters, so it collapses to 'Dual Function'.
     Values that aren't colour choices (Ditch Lights Kit, Brackets Only,
     4 Light Pillars) are left alone apart from casing. */
  function shortLabel(raw) {
    var t = String(raw).toLowerCase();

    if (t.indexOf('dual') > -1) return 'Dual Function';

    var main = t.match(/\b(white|yellow)\b/);
    if (!main) return titleCase(raw);

    var drlColor = null;
    if (t.indexOf('amber') > -1) drlColor = 'Amber';
    else if (t.indexOf('red') > -1) drlColor = 'Red';

    if (t.indexOf('drl') > -1 && drlColor) {
      return titleCase(main[1]) + ' + ' + drlColor + ' DRL';
    }
    return titleCase(main[1]);
  }

  function chosenValue() {
    var host = document.querySelector('#MainContent [data-product-options]');
    if (!host) return '';
    var out = [];
    var inputs = host.querySelectorAll('.radio__button input:checked');
    for (var i = 0; i < inputs.length; i++) {
      var lab = host.querySelector('label[for="' + inputs[i].id + '"] .option-title');
      if (lab) out.push(shortLabel(lab.textContent.trim()));
    }
    return out.join(' / ');
  }

  function syncButton() {
    var wrap = document.querySelector('#MainContent .product__submit__buttons');
    if (!wrap) return;
    var textEl = wrap.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    var priceSpan = textEl.querySelector('.btn__price');
    var value = chosenValue();
    var lead = textEl.querySelector('.mr-atc-lead');
    var line = document.querySelector('.mr-price-line');

    if (!lead || textEl.getAttribute('data-mr-label') !== value) {
      textEl.textContent = '';

      lead = document.createElement('span');
      lead.className = 'mr-atc-lead';
      lead.textContent = 'Add to cart';
      textEl.appendChild(lead);

      if (value) {
        var rest = document.createElement('span');
        rest.className = 'mr-atc-rest';
        rest.textContent = '\u2014 ' + value;
        textEl.appendChild(rest);
      }
      if (priceSpan) textEl.appendChild(priceSpan);

      textEl.setAttribute('data-mr-label', value);
    }

    if (line && priceSpan) line.textContent = priceSpan.textContent.trim();
  }

  function layout() {
    var wrap = document.querySelector('#MainContent .product__submit__buttons');
    if (!wrap) return;

    var qty = document.querySelector('#MainContent .product-form__quantity');
    if (qty && !qty.closest('.mr-qty-row')) {
      var row = document.createElement('div');
      row.className = 'mr-qty-row';
      var lbl = document.createElement('span');
      lbl.className = 'mr-qty-label';
      lbl.textContent = 'Quantity';
      row.appendChild(lbl);
      wrap.parentNode.insertBefore(row, wrap);
      row.appendChild(qty);
    }

    if (!document.querySelector('.mr-price-line')) {
      var price = document.createElement('span');
      price.className = 'mr-price-line';
      wrap.parentNode.insertBefore(price, wrap);
    }

    var textEl = wrap.querySelector('[data-add-to-cart-text]');
    if (textEl && !textEl.getAttribute('data-mr-watched') && window.MutationObserver) {
      textEl.setAttribute('data-mr-watched', '1');
      new MutationObserver(function () {
        if (textEl.querySelector('.mr-atc-lead')) return;
        textEl.removeAttribute('data-mr-label');
        syncButton();
      }).observe(textEl, { childList: true });
    }

    syncButton();
  }

  function run() {
    if (running) return;
    running = true;
    try {
      layout();
    } catch (e) {
      if (window.console) console.warn('mr-variant-cards:', e);
    }
    setTimeout(function () { running = false; }, 0);
  }

  function watch() {
    if (watching || !window.MutationObserver) return;
    var root = document.getElementById('MainContent');
    if (!root) return;
    watching = true;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        run();
      }, 30);
    }).observe(root, { childList: true, subtree: true });
  }

  function boot() {
    run();
    watch();

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('#MainContent [data-product-options]')) return;
      syncButton();
    });

    document.addEventListener('variant:change', function () { setTimeout(run, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
